module.exports = __webpack_public_path__ + "img/Heavy_Full_Metal_Sword.5e022102.png";